import axios from 'axios'
import '../../assets/css/global.css'
import '../../axios/axios.config'

//获取已分析的分组名，样本名
export function getAnalyzeGroupSampleNames(analyzeId) {
  return new Promise((resolve, reject) => {
    axios({
      url: '/analyze/textContent/' + analyzeId,
      method: 'get',
    }).then(res => {
      if (res) {
        if (res.code === 200) {
          const groups = res.data.groupNames.split(',')
          let data = {}
          let groupSample = []
          groups.map(item => {
            groupSample.push({
              groupName: item,
              sampleName: res.data.contact[item]
            })
          })
          data.groupSample = groupSample
          data.nonGroup = res.data.nonGroup
          resolve(data)
        } else {
          resolve("")
        }
      }
    }).catch(err => {
      reject(err)
    })
  })
}

export function reRunAnalyze(groupColor, analyzeId) {
  return new Promise((resolve, reject) => {
    let temGroup = JSON.parse(JSON.stringify(groupColor))
    let groupOrder=[]
    temGroup.forEach(item => {
      groupOrder.push(item.groupName)
    })
    temGroup.sort((a, b) => {
      var value1 = a.groupName;
      var value2 = b.groupName;
      if (value1 < value2) {
        return -1;
      } else if (value1 > value2) {
        return 1;
      } else {
        return 0;
      }
    })
    let color = temGroup.map(item=>item.color)
    const data = {'groupColor': color.join(':'),'groupOrder':groupOrder.join(":"),'sampleOrder':groupOrder.join(":")}
    axios.post('/anewRun/' + analyzeId, data).then(res => {
      if (res.code === 200) {
        resolve('success')
      }
    }).catch(err => {
      reject('err')
    })
  })
}

//检查报告的下载状态

export function checkReportDownload(analyzeId) {
  return new Promise((resolve, reject) => {
    axios.get('/preview/checkReportDownload/' + analyzeId).then(res => {
        resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
